 {
    "common": {
    "thisWeek": "Tämä viikko",
    "lastWeek": "Viime viikko",
    "lastNumberOfDays": "Viimeiset {numberOfDays} päivää",
    "thisMonth": "Tämä kuukausi"
    },
    "subAccounts": "Alatilit",
    "submitFeedback": "Lähetä palautetta",
    "createSubAccount": "Luo alatili",
    "viewScheduleReports": "Tarkastele aikataulutettuja raportteja",
    "searchSubAccount": "Hae alatilin mukaan",
    "columns": "Sarakkeet",
    "sortBy": "Lajitteluperuste",
    "selectColumns": "Valita sarakkeet",
    "maxColumns": "Maksimi 8 saraketta Päivämäärässä",
    "applyColumns": "Käytä sarakkeita",
    "activeUsers": "Aktiiviset käyttäjät",
    "appointments": "Tapaamiset",
    "contacts": "Kontaktit",
    "emails": "Gmail",
    "textMessages": "Runko-viestejä",
    "calls": "Puhelut",
    "submissions": "Vastauslähetykset",
    "reviews": "Arvostelut",
    "sitesCreated": "Sivustot luotu",
    "name": "Nimi",
    "formSubmissions": "Lomakkeiden lähetykset",
    "surveySubmissions": "Kyselyvastaukset",
    "facebookFormSubmissions": "Facebook-lomakkeiden lähetykset",
    "funnels": "Suppilot",
    "websites": "Verkkosivustot",
    "forms": "Lomakkeet",
    "surveys": "Kyselyt",
    "highestFirst": "Maksimi ensin",
    "lowestFirst": "Alhaisin ensin",
    "orderBy": "Järjestää Kautta",
    "noMoreLocations": "Ei enempää Osoite löytämistä",
    "preparingReport": "Raporttiasi valmistellaan…",
    "preparingReportDesc": "Älä sulje tätä ikkunaa tai lataa sitä uudelleen, kun vienti on käynnissä.",
    "outOf": "-",
    "subAccountsExported": "Alatilit viety",
    "close": "Sulje",
    "scheduledForDeletion": "Ajoitettu poistettavaksi",
    "readyToSell": "Valmis myytäväksi",
    "closedWon": "Suljettu (toteutunut)",
    "wpSaleSuccessful": "WordPress-myynti on onnistunut",
    "wpNotSold": "WordPress ei ole vielä myyty",
    "yxtSaleSuccessful": "Yext-myynti on onnistunut",
    "yxtNotSold": "Yextiä ei ole vielä myyty",
    "saasSubInactive": "SaaS Tilaus on Inaktiivinen",
    "saasSubTrialing": "SaaS Tilaus on kokeilussa",
    "saasSubActive": "SaaS Tilaus on Dynaaminen",
    "emailRebillingActive": "Sähköposti Uudelleenlaskutus on Dynaaminen",
    "emailRebillingInactive": "Sähköposti Uudelleenlaskutus on Inaktiivinen",
    "twilioRebillingActive": "Twilio Uudelleenlaskutus on Dynaaminen",
    "twilioRebillingInactive": "Twilio Uudelleenlaskutus on Inaktiivinen",
    "wpRebillingActive": "WhatsApp-uudelleenlaskutus on aktiivinen",
    "wpRebillingInactive": "WhatsApp-uudelleenlaskutus on inaktiivinen",
    "saasModeActivated": "SaaS -tila on Käytössä",
    "paymentPending": "Maksu on käynnissä",
    "saasModeNotActivated": "SaaS -tila ei ole Käytössä",
    "managedByLCPhone": "Hallinnoida Kautta LC Puhelin",
    "migrationToLCPhone": "Siirto käynnissä LC Puhelin",
    "notManagedByLCPhone": "Ei Hallinnoida Kautta LC Puhelin",
    "managedByLCEmail": "Hallinnoida Kautta LeadConnector Email System",
    "notMangedByLCEmail": "Ei Hallinnoida Kautta LeadConnector Email System",
    "remainingWalletBalance": "Tämän SaaS-sijainnin jäljellä oleva lompakkosaldo",
    "reports": "Raportit",
    "switchToSubAccount": "Vaihda alatiliin",
    "manageClient": "Hallinnoi asiakasta",
    "subAccountDeletedIfChangedMind": "Tämä alatili poistetaan {time}, jos olet muuttanut mieltäsi",
    "subAccountDeletedInMinute": "Tämä alatili poistetaan seuraavan minuutin aikana",
    "changedMind": "Jos Sinä/Te've Dynaaminen mieltäsi",
    "clickHere": "napsauttaa tässä",
    "subAccountPaused": "Tämä alatili on keskeytetty. Asiakkaasi eivät voi kirjautua sisään, mutta toimisto voi. Jatkaaksesi tämän tilin käyttöä",
    "subAccountRestricted": "Tämä alatili on keskeytetty keskeneräisen hyväksyntäprosessin vuoksi.",
    "subAccountVerificationPending": "Tämä alatili on keskeytetty, koska alatilin järjestelmänvalvojan sähköposti- ja puhelinvahvistus on kesken.",
    "subAccountDeclined": "Tämä alatili on keskeytetty, koska hyväksyntäpyyntö hylättiin. Voit yhä jatkaa tämän alatilin käyttöä ",
    "here": "tässä.",
    "reviewAndResume": "tarkistaaksesi ja jatkaaksesi tämän alatilin käyttöä.",
    "incomingCalls": "Saapuvat puhelut",
    "outgoingCalls": "Lähtevät puhelut",
    "totalTalktime": "Puheaika Yhteensä",
    "incomingEmails": "Saapuva Gmail",
    "outgoingEmails": "Lähtevä Gmail",
    "incomingSms": "Saapuvat Runko-viestit",
    "outgoingSms": "Lähtevät Runko-viestit",
    "contactsCreated": "Yhteystietoja luotu yhteensä",
    "appointmentsBooked": "Tapaamisia varattu yhteensä",
    "totalFormSubmissions": "Lomake-lähetyksiä yhteensä",
    "totalSurveySubmissions": "Kyselyn yhteensä vastauslähetyksiä",
    "totalFacebookFormSubmissions": "Facebook-lomakelähetyksiä yhteensä",
    "incomingGMBMessages": "Saapuvat GBP-viestit",
    "outgoingGMBMessages": "Lähtevät GBP-viestit",
    "gmbMessages": "GBP-viestit",
    "fbMessages": "Facebook-viestit",
    "incomingFbMessages": "Saapuvat Facebook-viestit",
    "outgoingFbMessages": "Lähtevät Facebook-viestit",
    "igMessages": "Instagram-viestit",
    "incomingIgMessages": "Saapuvat Instagram-viestit",
    "outgoingIgMessages": "Lähtevät Instagram-viestit",
    "totalReviews": "Arvosteluja Yhteensä",
    "positiveReviews": "Positiiviset arvostelut",
    "negativeReviews": "Negatiiviset arvostelut",
    "back": "Takaisin",
    "selectDashboards": "Valita raporttinäkymät",
    "next": "Seuraava",
    "backToSubAccounts": "Takaisin alatileihin",
    "pauseSchedule": "aikataulu Keskeytä",
    "resumeSchedule": "Jatkaa aikataulu",
    "editSchedule": "Muokkaa aikataulua",
    "addSchedule": "Lisää aikataulu",
    "selectReportToAdd": "Valita raportoi Sisällyttäälle in",
    "selectAll": "Valita huone",
    "pauseScheduleConfirm": "Haluatko Sinä/Te varma, että Sinä/Te Keskeytä raporttia aikataulussa?",
    "resumeScheduleConfirm": "Haluatko Sinä/Te varma Sinä/Te Jatkaa raportin aikataulun?",
    "tasks": "Tehtävät",
    "conversations": "Keskustelut",
    "users": "Käyttäjä",
    "dealOverview": "Sopimus Yleiskatsaus",
    "confirmAction": "Vahvista toiminto",
    "yes": "Kyllä",
    "no": "Ei",
    "reportDetails": "Raportin tiedot",
    "reportCreatedOn": "Ilmianna Luotu Päällä",
    "searchByEmail": "Hakea Kautta sähköposti",
    "lastActivity": "Viimeisin toiminta",
    "noRecords": "Tietueita ei löytynyt",
    "scheduleReport": "Ajoita raportti",
    "schedule": "aikataulu",
    "save": "Tallenna",
    "emailSubject": "Aiherivi",
    "frequency": "Esiintymistaajuus",
    "daily": "Päivittäinen",
    "weekly": "Viikoittainen",
    "monthly": "Kuukausitttainen",
    "nextScheduleDate": "Seuraava aikataulu päivämäärä",
    "startingOn": "Alkaen Päällä",
    "timeOfDay": "Päivämäärä - Päivä",
    "reportsToTimezone": "Raportti lähetetään alatilin aikavyöhykkeen mukaan",
    "selectRecipients": "Valita vastaanottajat",
    "invalidEmail": "Anna kelvollinen sähköpostiosoite.",
    "testEmail": "Testata Sähköposti",
    "selectTestRecipients": "Valita Testata vastaanottajat",
    "setupSubject": "Määrittää edellä olevan Aihe Testatalle raportin",
    "sendTest": "Ladata Testata",
    "scheduleSimilarSchedules": "Ajoita samanlainen raportti muille alatileille",
    "accountSummary": "Tilin yhteenveto",
    "scheduleList": "Aikataululuettelo",
    "subAccountName": "Alatilin nimi",
    "nextRunDate": "Seuraava suorituspäivä",
    "reportSectionsAdded": "Raportin osiot lisätty",
    "status": "Tila",
    "scheduleAction": "Ajoita toiminto",
    "cancel": "Peruuta",
    "pleaseWait": "Ladataan…",
    "confirm": "Vahvista",
    "booked": "Varattu",
    "confirmed": "Vahvistettu",
    "showed": "Osallistunut",
    "noShow": "Ei tullut tapaamiseen",
    "cancelled": "Peruutettu",
    "unread": "Lukemattomat",
    "engagement": "Kihlaus",
    "reaction": "Reaktio",
    "deliverySummary": "Toimituksen yhteenveto",
    "successfulDelivery": "Onnistunut toimitus",
    "opened": "Avattu",
    "clicked": "Napsautettu",
    "replied": "Vastattu",
    "unsubscribed": "Tilaus peruutettu",
    "complained": "Valitettu",
    "failed": "Epäonnistunut",
    "bounced": "Palautunut",
    "open": "Avoinna",
    "won": "Voitettu",
    "abandoned": "Hylätty",
    "lost": "Menetetty",
    "sent": "Lähetetty",
    "eject": "Poistaa",
    "delivered": "Toimitettu",
    "faceBookLeadForm": "Facebook-liidilomake",
    "overdue": "Erääntynyt",
    "reviewsReceived": "Arvostelut Vastaanotettu",
    "formBuilders": "Lomakkeenrakennustyökalut",
    "switchToSaaS": "Vaihda SaaS",
    "numberOfContacts": "Kontaktien kokonaismäärä",
    "numberOfAppointments": "Tapaamisten kokonaismäärä",
    "outreach": "Yhteistyö",
    "notSubAccountUser": "Ei ole alatilin käyttäjä",
    "searchSubAccName": "Hae alatilin nimellä",
    "recipients": "Vastaanottajat",
    "scheduleCreated": "Sähköpostiraportin aikataulu luotu kohteelle ",
    "scheduleUpdated": "Sähköpostiraportin aikataulu päivitetty kohteelle ",
    "scheduleNotCreated": "Sähköpostiraportin aikataulua ei voitu luoda kohteelle",
    "scheduleNotUpdated": "Sähköpostiraportin aikataulua ei voitu päivittää kohteelle",
    "total": "Yhteensä",
    "inbound": "Saapuva",
    "outbound": "Lähtevä",
    "totalEmails": "Sähköpostien kokonaismäärä",
    "inboundEmails": "Saapuvat sähköpostit",
    "outboundEmails": "Lähtevät sähköpostit",
    "totalTextMessages": "Tekstiviestien kokonaismäärä",
    "inboundTextMessages": "Saapuvat tekstiviestit",
    "outboundTextMessages": "Lähtevät tekstiviestit",
    "totalCalls": "Puheluita yhteensä",
    "inboundCalls": "Saapuvat puhelut",
    "outboundCalls": "Lähtevät puhelut",
    "faceBookLeadFormSubmissions": "Facebookin liidilomakelähetykset",
    "inboundGMBMessages": "Saapuvat GBP-viestit",
    "outboundGMBMessages": "Lähtevät GBP-viestit",
    "totalIgMessages": "Instagram-viestien kokonaismäärä",
    "inboundIgMessages": "Saapuvat Instagram-viestit",
    "outboundIgMessages": "Lähtevät Instagram-viestit",
    "totalfbMessages": "Facebook-viestien kokonaismäärä",
    "inboundfbMessages": "Saapuvat Facebook-viestit",
    "outboundfbMessages": "Lähtevät Facebook-viestit",
    "sitesCreatedFunnels": "Luodut sivustot – suppilot",
    "sitesCreatedActiveFunnels": "Luodut sivustot – aktiiviset suppilot",
    "sitesCreatedWebsites": "Luodut sivustot – verkkosivustot",
    "sitesCreatedActiveWebsites": "Luodut sivustot – aktiiviset verkkosivustot",
    "sitesCreatedForms": "Luodut sivustot – lomakkeet",
    "sitesCreatedActiveForms": "Luodut sivustot – aktiiviset lomakkeet",
    "sitesCreatedSurveys": "Luodut sivustot – kyselyt",
    "sitesCreatedActiveSurveys": "Luodut sivustot – aktiiviset kyselyt",
    "googleReviews": "Google-arvostelut",
    "facebookReviews": "Facebook-arvostelut",
    "inboundCallDuration": "Saapuvien puheluiden kesto (tuntia)",
    "outboundCallDuration": "Lähtevien puheluiden kesto (tuntia)",
    "pleaseSelect": "Valitse",
    "subAccountIsDeleted": "Tämä alatili on poistettu",
    "subAccountIsPaused": "Tämä alatili on keskeytetty",
    "success": "Onnistui",
    "error": "Virhe",
    "testEmailSent": "Testata sähköposti lähetetty",
    "testEmailNotSent": "Testata-sähköpostia ei voitu lähettää",
    "reviewRequest": "Arvostelupyynnöt",
    "pendingTransferDescription": "Muut toimistot ovat pyytäneet alatilien siirtämistä sinulle.",
    "pendingTransferHeading": "Sinulla on odottavia alatilien siirtopyyntöjä.",
    "subAccountTransfer": "Alatilien siirrot",
    "manageSubAccTransfer": "Hallinnoi alatilien siirtopyyntöjä",
    "subAccRequest": "Alatilien {tabName}-pyynnöt",
    "receive": "Periä",
    "send": "Lähetä",
    "release": "Julkaista",
    "requests": "{count} pyyntöä",
    "subAccLimit": "Alatilien käyttöraja on saavutettu.",
    "subAccPlanLimit": "Olet ottanut käyttöön kaikki 3/3 alatiliä, jotka kuuluvat nykyiseen tilaukseesi.",
    "upgradeTime": "On aika päivittää!",
    "upgradeHigher": "Päivitä parempaan tilaukseen, jotta voit hyväksyä alatilin siirron.",
    "browse": "Selaa tilauksia",
    "pendingTransferTitle": "Tämän alatilin siirtopyyntö on jo vireillä.",
    "unableTransfer": "Alatiliä ei voida ladata tälle toimistolle.",
    "unableEjectCancel": "Alatilin poistopyyntöä ei voida peruuttaa.",
    "EjectErrorDetails": "Alatilin poistopyyntöä ei voida peruuttaa.",
    "hippaErrorDescription": "Tämä alatili on HIPAA-yhteensopiva. Sitä ei voi siirtää toimistolle, joka ei ole HIPAA-yhteensopiva.",
    "pendingTransferErrorDescription": "Peruuta tämän alatilin olemassa oleva siirtopyyntö ennen uuden luomista.",
    "receivingAgency": "Vastaanottava toimisto",
    "releasingAgency": "Lähettävä toimisto",
    "noOfContacts": "Kontaktien kokonaismäärä",
    "requestedDate": "Pyyntöpäivä",
    "action": "Toiminta",
    "cancelTransfer": "Peruuta siirto",
    "decline": "Hylätä",
    "cancelTransferRequest": "Peruutetaanko alatilin siirtopyyntö?",
    "cancelEjectRequest": "Peruutetaanko alatilin poistopyyntö?",
    "cancelRequestDescription": "Vastaanottava toimisto ei enää näe tätä siirtopyyntöä, eikä alatiliä {name} siirretä.",
    "cancelEjectRequestDescription": "Valittu käyttäjä ei enää voi luoda uutta toimistoa alatilistä {name}.",
    "declineRequest": "Hylätäänkö alatilin siirtopyyntö?",
    "declineRequestDescription": "Pyyntö hylätään, eikä alatiliä {name} siirretä toimistollesi.",
    "approveTransfer": "Hyväksytkö alatilin siirron toimistollesi?",
    "approveTransferDescription": "Alatili {name} siirretään toimistollesi.",
    "transferNow": "Siirrä nyt",
    "cancelNow": "Peruuta nyt",
    "transferErrorDetails": "Tätä alatiliä ei voida siirtää.",
    "cancelRequest": "Peruuta pyyntö",
    "received": "Vastaanotettu",
    "approve": "Hyväksyä",
    "goBack": "Palaa takaisin",
    "done": "Valmis",
    "subAccountTransferred": "Alatilin siirto onnistui!",
    "subAccountTransferDescription": "Vaikka alatili on nyt siirretty, jotkin resurssit, kuten käyttäjät, puhelinnumerot, Mailgun-tilit ja Yext-listaukset, saattavat näkyä kohteessa vasta 10–15 minuutin kuluttua.",
    "activeSubscriptionsAlert": "Sijaintissa on Dynaaminen Tilaus. Ole hyvä Peruuttaa Tilaus Ennen Sokkosiirtoa the sijainti. Luettelo – Dynaaminen Tilaus: {subscriptions}",
    "isSaasEnabled": "SaaS käytössä",
    "typeToSearch": "Hae kirjoittamalla",
    "dateAdded": "Lisäämispäivä",
    "emailEngagement": "Sähköpostisitoutuminen",
    "emailReaction": "Sähköpostireaktiot",
    "emailDeliverySummary": "Yhteenveto sähköpostien toimituksesta",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Tilin yhteenveto – {subAccountName}",
    "test": "Testata",
    "scheduleExists": "Aikataulu on olemassa",
    "aToZ": "A–Z",
    "zToA": "Z–A",
    "onlyAdminUsersCanAddNewSubAccounts": "Vain ylläpitäjäkäyttäjät voivat lisätä uusia alatilejä.",
    "locationName": "Sijainnin nimi",
    "transferCompleted": "Tämän sijainnin siirtopyyntö on jo käsitelty. Päivitä sivu.",
    "unauthorizedTransfer": "Sinä/Te ei ole valtuutettu suorittamaan tätä toimintoa. Vain Toimiston omistajat voivat suorittaa tämän toiminnan.",
    "bulkLocationTransfer": "Alatilien massasiirto",
    "singleRequest": "Yksittäinen pyyntö",
    "bulkRequest": "Massapyyntö",
    "backToLocationTransfer": "Takaisin sijainnin siirtoon",
    "initiateBulkTransfer": "Aloita alatilien massasiirto",
    "initiateBulkTransferDescription": "Valitse alatilit, jotka haluat siirtää, tai syötä niiden tunnukset pilkuilla eroteltuina.",
    "subAccountId": "Alatilin tunnus",
    "selectFromList": "Valitse luettelosta",
    "addManually": "Lisää manuaalisesti",
    "accountsSelected": "{count} valittu",
    "selectAllSubAccounts": "Valita huone",
    "removeAll": "Poista kaikki",
    "addManualLocations": "Lisää sijaintitunnukset pilkuilla eroteltuina",
    "manualAllLocationIds": "Sijaintitunnukset - ala-Tili Sinä/Te-toiveet Siirtää, Erotettu Kautta pilkulla.",
    "enterLocationIds": "Anna sijaintitunnukset",
    "selectSubAccounts": "Valitse alatilit ja siirrä ne olemassa olevalle toimistolle",
    "subAccountTransferWarning": "prie sub-Tilivarat ja Käyttäjät saavat Ladata.",
    "proceed": "Edetä",
    "bulkRequestSubmitted": "Massasiirtopyyntö lähetetty",
    "bulkRequestSubmittedDescription": "Alatilit siirretään, kun vastaanottava toimisto hyväksyy siirtopyynnön. Voit seurata pyynnön tilaa ❝{pagename}❞-sivulla. (edellyttäen, että ehdot täyttyvät)",
    "bulkTransferRequestFailed": "Massasiirtopyyntö epäonnistui",
    "errorLocations": "Virheelliset alatilit",
    "viewDetails": "Näytä tiedot",
    "somethingWrong": "Jokin meni pieleen. Yritä uudelleen.",
    "confirmBulkRequest": "Vahvistetaanko massasiirtopyyntö?",
    "bulkTransferAccounts": "{count} valitun alatilin massasiirto?",
    "confirmDetails": "Vahvista tiedot ennen siirtoa.",
    "transferConsent": "Minulla on Lukea ja ymmärtänyt yllä olevan oppaan ja Suostumus ton rajoitukset.",
    "transferInfo": "Alatilin siirtäminen edellyttää, että vastaanottava toimisto hyväksyy sen tililleen.",
    "receivingRelNo": "Vastaanottavan toimiston suhdenumero",
    "enterRelNo": "Anna suhdenumero",
    "transferConfirmation": "Tämän toiminnan päätyttyä Massa-Siirtää Pyynnöt lähetetään osoitteeseen Vastaanotettu Toimisto ({ relNo }). prie sub-Tili Sinä/Te've Valittu on Ladata, kun Vastaanotettu Toimisto hyväksyy sen. Muistiinpano, että tämä on peruuttamatonta in sisältyvälle Toiminta-ala-Tilille.",
    "confirmPassword": "Vahvista Kautta- password (jonkin) ala side",
    "enterPassword": "Anna salasana",
    "requestTransfer": "Pyydä siirtoa",
    "confirmTransfer": "Vahvista siirto",
    "notNow": "Ei nyt",
    "invalidRelNo": "Vanhentunut suhdenumero",
    "invalidPassword": "Virheellinen password.",
    "searchSubAccounts": "Hae alatilejä",
    "searchSubAccountsId": "Hae alatilin tunnusta",
    "takeAction": "Toimi",
    "sub_account_details": "Alatilin tiedot",
    "no_of_contacts": "Kontaktien kokonaismäärä",
    "transfer_status": "Siirron tila",
    "error_info": "Virhetiedot",
    "bulk_transfer_status": "Alatilien massasiirron tila",
    "pending": "Odottavat",
    "processed": "Käsitelty",
    "reject_all": "Hylkää kaikki",
    "accept_all": "Hyväksy kaikki",
    "cancel_all": "Peruuta kaikki",
    "clearAll": "Tyhjennä kaikki",
    "refresh": "Päivitä",
    "rejected": "Kielletty",
    "decline_transfer": "Hylkää siirto",
    "decline_bulk_transfer": "Hylätäänkö alatilien massasiirtopyyntö?",
    "decline_bulk_transfer_description": "Pyyntö hylätään, eikä {length} alatiliä siirretä toimistollenne.",
    "accept_bulk_transfer": "Hyväksytäänkö alatilien massasiirtopyyntö?",
    "accept_bulk_transfer_description": "Pyyntö hyväksytään ja {length} alatiliä siirretään toimistollenne.",
    "cancel_bulk_transfer": "Peruutetaanko massasiirto?",
    "cancel_bulk_transfer_description": "Haluatko varmasti peruuttaa {length} alatilin massasiirron toimistolle ”{name}”?",
    "consent_sub_account_transfer": "Lukea ja Suostumus vastaanottajalle {link}",
    "sub_account_transfer_guidelines": "Alatilien siirtoa koskevat ohjeet",
    "valid_rel": "Anna kelvollinen luku",
    "something_went_wrong": "Jokin meni pieleen. Yritä uudelleen.",
    "export": "Vie",
    "export_success": "Sinä/Teen pyytämiä tietoja käsitellään. Sinä/Te lähettää sähköpostin, jossa on tiedot in päivämäärässä.",
    "export_failed": "Sinä/Te pyytämiä tietoja ei voitu käsitellä. Yrittää myöhemmin uudelleen.",
    "selectAllError": "Voit valita enintään 1 000 alatiliä kerrallaan.",
    "max1000": "(Maks. 1 000)",
    "subAccountCount": "Alatilien määrä",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Haluatko Sinä/Te varma, että Sinä/Te Keskeytä {count} raportoi?",
    "scheduleBulkResumeConfirm": "Haluatko Sinä/Te varma, että Sinä/Te Jatkaan {count} raportoi?",
    "resume": "Jatka",
    "pause": "Keskeytä",
    "resumeSelected": "Jatkaa Valittu",
    "pauseSelected": "Keskeytä Valittu",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} raporttia valittu",
    "selectAllXReports": "Valitse kaikki {count} raporttia",
    "scheduleStatus": "Aikataulun tila",
    "scheduleSearchPlaceholder": "Hae käyttämällä sähköpostia tai sijainnin nimeä",
    "subAccountsPerPage": "Alatilejä sivua kohden",
    "previous": "Edellinen",
    "scheduleBulkAction": "Aikatauluta massatoiminto",
    "all": "Kaikki",
    "active": "Aktiivinen",
    "paused": "Keskeytetty",
    "scheduleUpdatedSuccessfully": "Päivitetty onnistui",
    "saveChanges": "Tallenna muutokset",
    "pauseSchedulesTitle": "Keskeytä Aktiivinen Ajoitettu raportoi",
    "pauseSchedulesDescription": "napsauttaa to Keskeytä nyt Aktiivinen raportit.",
    "pauseSchedulesAlert": "Tämä vaikuttaa vain Tileihin, jotka ovat nyt Dynaaminen.",
    "pauseAllSchedulesBtnText": "Keskeytä kaikki ajastetut raportit",
    "autoScheduleTitle": "Aikatauluta uudet tilit automaattisesti",
    "autoScheduleLabel": "Luo ajoitetut raportit automaattisesti, kun uusi alatili lisätään.",
    "autoScheduleAlert": "Poistaa tämä Jos Sinä/Te haluat Määrittää uudelle Tilille manuaalisesti.",
    "autoScheduleEnabledForNewAccounts": "Auto-Ajoittaa Käytössä uudelle Tilille",
    "autoScheduleDisabledForNewAccounts": "Auto-Ajoittaa Poistettu uudelle Tilille",
    "deleted": "Poistettu",
    "locationPaused": "Sijainti on keskeytetty",
    "scheduleSettingsModalTitle": "aikataulu raportti Asetukset",
    "selectAllSchedules": "Valita Ajoittaa",
    "selectScheduleForLocation": "Valita aikataulu kohteelle {location}",
    "openSettings": "Avata Asetukset",
    "resumeScheduleForLocation": "Jatkaa aikataulu {location}aikataulua",
    "pauseScheduleForLocation": "aikataulu Keskeytä : {location}",
    "actions": "Toiminnot",
    "deselectAll": "Poista valinta",
    "scheduleBulkActionResumeSuccess": "Massa- aktivointi in — Pito Poistettu Päällä uudet toiminnot",
    "scheduleBulkActionPauseSuccess": "Keskeytetään raportit – odota ennen kuin ryhdyt lisätoimiin",
    "bulkActionCreationError": "Käynnissä on toinen massatoiminto. Yritä hetken kuluttua uudelleen.",
    "bulkActionInProgress": "Massa-toiminta on jo in",
    "scheduledReports": "Ajoitettu raportteja",
    "scheduleBulkActionCompleted": "Massa- Toiminta Tehty onnistui",
    "pauseAllSchedulesModalTitle": "Keskeytetäänkö raportit?",
    "pauseAllSchedulesModalText": "Tämä keskeyttää kaikki aktiiviset aikataulutetut raportit kaikilla alatileillä.",
    "addLocationIdsPlaceholder": "Lisää siirrettävien sijaintien tunnukset…",
    "helloWorld": {
      "count": "Lukumäärä on {count}",
      "editIntro": "Muokkaa",
      "editAction": "HMR:n testaamiseksi",
      "checkOut": "Tarkista",
      "officialStarter": ", virallinen Vue + Vite ‑aloitus",
      "install": "Asenna",
      "installDescription": "IDE-ympäristöösi paremman DX:n saavuttamiseksi",
      "learnMore": "Lisätietoja saat klikkaamalla Vite- ja Vue-logoja"
    },
    "home": {
      "testMessage": "Hei! Tämä on testialoitussivu!"
    },
    "reports": {
      "incoming": "Saapuvat",
      "outgoing": "Lähtevät",
      "duration": "Kesto",
      "contactsCount": "Kontaktien kokonaismäärä",
      "appointmentsCount": "Tapaamisten kokonaismäärä",
      "formSubmissions": "Lomakkeiden lähetykset",
      "surveySubmissions": "Kyselyvastaukset",
      "facebookFormSubmissions": "Facebook-lomakkeiden lähetykset",
      "funnels": "Suppilot",
      "websites": "Verkkosivustot",
      "forms": "Lomakkeet",
      "surveys": "Kyselyt",
      "gbpMessages": "GBP-viestit",
      "facebookMessages": "Facebook-viestit",
      "instagramMessages": "Instagram-viestit",
      "reviews": "Arvostelut",
      "positives": "Positiiviset",
      "negatives": "Negatiiviset"
    },
    "timeOptions": {
      "00": "Klo 0.00",
      "01": "Klo 1.00",
      "02": "Klo 2.00",
      "03": "Klo 3.00",
      "04": "Klo 4.00",
      "05": "Klo 5.00",
      "06": "Klo 6.00",
      "07": "Klo 7.00",
      "08": "Klo 8.00",
      "09": "Klo 9.00",
      "10": "Klo 10.00",
      "11": "Klo 11.00",
      "12": "Klo 12.00",
      "13": "Klo 13.00",
      "14": "Klo 14.00",
      "15": "Klo 15.00",
      "16": "Klo 16.00",
      "17": "Klo 17.00",
      "18": "Klo 18.00",
      "19": "Klo 19.00",
      "20": "Klo 20.00",
      "21": "Klo 21.00",
      "22": "Klo 22.00",
      "23": "Klo 23.00"
    },
    "transferStatus": {
      "pending": "Kesken",
      "processed": "Käsitelty",
      "canceled": "Peruutettu",
      "cancelled": "Peruutettu",
      "completed": "Valmis",
      "rejected": "Hylätty",
      "failed": "Epäonnistui",
      "payment_pending": "Odottaa maksua"
    }
    }
